import React, { useContext } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../providers/AuthProvider';
import {
	trackError,
	ERROR_CONTEXTS,
} from '../../../services/analytics.service';
import {
	COLOR_DRAWER_ICON_LOGOUT,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const Logout = () => {
	const { signOut } = useContext(AuthContext);
	const navigate = useNavigate();

	const handleClick = async () => {
		try {
			await signOut();
		} catch (err) {
			trackError(ERROR_CONTEXTS.LOGOUT, err);
		} finally {
			navigate('/');
		}
	};

	return (
		<ListItem key={'Logout'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{ color: COLOR_DRAWER_ICON_LOGOUT, minWidth: '40px' }}
				>
					<LogoutIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Logout'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
